import { createApiAction, showNotification } from 'services/api';
import {
  StartAction,
  SuccessAction,
  FailureAction,
} from 'services/api/redux/types';
import { Tenant } from '../types';

export enum TenantsActionTypes {
  PUT_TENANTS_START = 'tracking/put_tenants_start',
  PUT_TENANTS_SUCCESS = 'tracking/put_tenants_success',
  PUT_TENANTS_FAILURE = 'tracking/put_tenants_failure',

  FETCH_TENANTS_START = 'tenants/fetch_tenants_start',
  FETCH_TENANTS_SUCCESS = 'tenants/fetch_tenants_success',
  FETCH_TENANTS_FAILURE = 'tenants/fetch_tenants_failure',
}

export const updateTenants = (tenant: Tenant) =>
  createApiAction(
    {
      path: `/v1/users/tenants/${tenant.id}`,
      method: 'PUT',
      body: tenant,
    },
    putTenantsActionStart,
    putTenantsActionSuccess,
    putTenantsActionFailure
  );


const putTenantsActionStart = (): StartAction => ({
  type: TenantsActionTypes.PUT_TENANTS_START,
  payload: null,
});

const putTenantsActionSuccess = (payload: any): SuccessAction => {
  showNotification('Tenants successfully updated', {
    variant: 'success',
  });
  return {
    type: TenantsActionTypes.PUT_TENANTS_SUCCESS,
    payload,
  };
};

const putTenantsActionFailure = (error: any): FailureAction => {
  showNotification(error.message, { variant: 'error' });
  return {
    type: TenantsActionTypes.PUT_TENANTS_FAILURE,
    payload: { error },
  };
};

// TENANT ACTIONS
const fetchTenantsActionStart = (): StartAction => ({
  type: TenantsActionTypes.FETCH_TENANTS_START,
  payload: null,
});

const fetchTenantsActionSuccess = (payload: any): SuccessAction => {
  return {
    type: TenantsActionTypes.FETCH_TENANTS_SUCCESS,
    payload,
  };
};

const fetchTenantsActionFailure = (error: string): FailureAction => ({
  type: TenantsActionTypes.FETCH_TENANTS_FAILURE,
  payload: { error },
});

export const fetchTenants = () =>
  createApiAction(
    {
      path: '/v1/users/tenants',
      method: 'GET',
    },
    fetchTenantsActionStart,
    fetchTenantsActionSuccess,
    fetchTenantsActionFailure
  );
